module.exports = __webpack_public_path__ + "static/img/MG.b1031f39.jpg";